import NextLink from 'next/link';
import React, { ReactNode } from 'react';

import classNames from '@/helpers/classNames';

import styles from './Link.module.scss';

interface LinkProps extends React.ComponentPropsWithoutRef<'a'> {
  children: ReactNode;
  underline?: boolean;
  variant?: 'blue' | 'white' | 'grey' | 'black';
  size?: 'small' | 'medium' | 'large' | 'largeNormal';
  isInline?: boolean;
  disableHover?: boolean;
  prefetch?: boolean;
}

export default function Link(props: LinkProps) {
  const {
    href,
    children,
    className,
    underline = true,
    variant = 'blue',
    size = 'medium',
    isInline,
    disableHover = false,
    prefetch,
    ...linkProps
  } = props;

  const linkClassName = classNames(
    [styles.link, styles[variant], styles[size], className],
    {
      [styles.underline]: underline,
      [styles.inline]: isInline,
      [styles.disableHover]: disableHover,
    }
  );

  if (href) {
    return (
      <NextLink
        {...linkProps}
        href={href}
        className={linkClassName}
        prefetch={prefetch}
      >
        <span className={styles.linkContent}>{children}</span>
      </NextLink>
    );
  }

  return null;
}
